import React, { Component } from 'react'
import { Transfer, Table, Input, Space, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import difference from 'lodash/difference'

export interface Column { 
  dataIndex: string,
  title: string,
  searchable?: boolean,
  filterIcon?: any,
  filterDropdown?: any,
  onFilter?: any,
  render?: any
}

export interface TableTransferProps {
  leftColumns: Column[],
  rightColumns: Column[],
  listStyle: any,
  dataSource: any,
  targetKeys: string[],
  onChange: any,
  onSelectChange: any
}

export default class TableTransfer extends Component<TableTransferProps> {

  // Search input reference
  searchInput: any = null

  // Transfer reference
  container = React.createRef() as any

  // Preseved container size
  presevedSize = null as any

  componentDidMount() {
    this._fixLayout()
  }

  _fixLayout = () => {
    if (this.container?.current && !this.presevedSize) {
      const { clientWidth, clientHeight } = this.container.current

      this.presevedSize = {
        width: clientWidth,
        height: clientHeight
      }

      // We got the right size, now we should re-render with the fixed size :D
      this.forceUpdate()
    }

    return this.presevedSize || {}
  }

  render() {
    const styles = this._fixLayout()

    return (
      <div ref={this.container} style={styles}>
        <Transfer {...this.props} className="table-transfer" style={styles} showSelectAll={false}>
          {({
            direction,
            filteredItems,
            onItemSelectAll,
            onItemSelect,
            selectedKeys: listSelectedKeys,
            disabled: listDisabled,
          }) => {
            let columns = direction === 'left' ? this.props.leftColumns : this.props.rightColumns

            // Search filter
            if (direction === 'left') {
              columns = columns.map(col => {
                if (col.searchable) {
                  col.filterIcon = (filtered: any) => <SearchOutlined style={{ color: filtered ? '@primary-color' : undefined }} />
                  col.filterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
                    <div style={{ padding: 8 }}>
                      <Input
                        ref={node => {
                          this.searchInput = node;
                        }}
                        placeholder='Search'
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => confirm()}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                      />
                      <Space>
                        <Button
                          type="primary"
                          onClick={() => confirm()}
                          icon={<SearchOutlined />}
                          size="small"
                          style={{ width: 90 }}
                        >
                          Search
                        </Button>
                        <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
                          Reset
                        </Button>
                      </Space>
                    </div>
                  )

                  // Frontend filter by search
                  if (!col.onFilter) {
                    col.onFilter = (value, record) => {
                      return record[col.dataIndex] ? record[col.dataIndex].toLowerCase().includes(value.toLowerCase()) : ''
                    }
                  }
                }

                return col
              })
            }

            const rowSelection = {
              getCheckboxProps: item => ({ disabled: listDisabled || item.disabled }),
              onSelectAll(selected, selectedRows) {
                const treeSelectedKeys = selectedRows
                  .filter(item => !item.disabled)
                  .map(({ key }) => key)
                const diffKeys = selected
                  ? difference(treeSelectedKeys, listSelectedKeys)
                  : difference(listSelectedKeys, treeSelectedKeys)
                onItemSelectAll(diffKeys, selected)
              },
              onSelect({ key }, selected) {
                onItemSelect(key, selected)
              },
              selectedRowKeys: listSelectedKeys,
            }


            return (
              <Table
                rowSelection={rowSelection}
                columns={columns}
                dataSource={filteredItems as any}
                size="small"
                style={{ width: '100%', height: '100%', pointerEvents: listDisabled ? 'none' : 'auto' }}
              />
            )
          }}
        </Transfer>
      </div>
    )
  }
}
